export const Input = ({ input, setOnChange }) => {
  return <input type="number" value={input} onChange={setOnChange} />;
};
